// src/pages/modifica.js

import React from 'react';
import { useParams } from 'react-router-dom';
import Nuovo from './Nuovo';

// La pagina Modifica carica un preventivo esistente e riutilizza tutta la logica di Nuovo
export default function Modifica() {
  const { id } = useParams(); // ID del preventivo passato nell'URL
  return <Nuovo preventivoId={id} />;
}